import type { UseFormReturn } from 'react-hook-form';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

export interface PasswordFormValues {
  currentPassword: string;
  newPassword: string;
  confirmPassword: string;
}

/** Campos de troca de senha compartilhados entre a troca forçada e a tela Minha conta. */
export function PasswordFields({
  form,
  idPrefix,
}: {
  form: UseFormReturn<PasswordFormValues>;
  idPrefix: string;
}) {
  const errors = form.formState.errors;
  return (
    <>
      <div className="space-y-2">
        <Label htmlFor={`${idPrefix}-current`}>Senha atual</Label>
        <Input
          id={`${idPrefix}-current`}
          type="password"
          autoComplete="current-password"
          {...form.register('currentPassword')}
        />
        {errors.currentPassword && (
          <p className="text-xs text-destructive">{errors.currentPassword.message}</p>
        )}
      </div>
      <div className="space-y-2">
        <Label htmlFor={`${idPrefix}-new`}>Nova senha</Label>
        <Input
          id={`${idPrefix}-new`}
          type="password"
          autoComplete="new-password"
          {...form.register('newPassword')}
        />
        <p className="text-xs text-muted-foreground">
          Pelo menos 8 caracteres, com letra e número.
        </p>
        {errors.newPassword && (
          <p className="text-xs text-destructive">{errors.newPassword.message}</p>
        )}
      </div>
      <div className="space-y-2">
        <Label htmlFor={`${idPrefix}-confirm`}>Confirmar nova senha</Label>
        <Input
          id={`${idPrefix}-confirm`}
          type="password"
          autoComplete="new-password"
          {...form.register('confirmPassword')}
        />
        {errors.confirmPassword && (
          <p className="text-xs text-destructive">{errors.confirmPassword.message}</p>
        )}
      </div>
    </>
  );
}
